module.exports = __webpack_public_path__ + "img/banner05.dc360b72.jpg";